import React from "react";
import ShortcutGroupDialogSkeleton from "./shortcutGroupDialogSkeleton";
import DialogField from "modules/common/components/dialogField";
import { Typography } from "@mui/material";

import "../../styles/editShortcutGroupDialog.sass";

interface IEditShortcutGroupDialogProps {
    show: boolean;
    onClose: () => void;
    onEditShortcutGroupFromInput: (shortcutGroupName: string) => void;
    shortcutGroupName: string;
}

const EditShortcutGroupDialog: React.FC<IEditShortcutGroupDialogProps> = ({
    show,
    onClose,
    onEditShortcutGroupFromInput,
    shortcutGroupName
}) => {
    const getExtraDialogField = (): JSX.Element => 
        <DialogField 
            fieldName={"Rename"} 
            fieldInput={<Typography>{shortcutGroupName}</Typography>}
            labelWidth={4}     
            fieldLabelGridClassName="edit-shortcut-group-field-label"
            fieldInputGridClassName="edit-shortcut-group-field-input"
        />;
    
    return <ShortcutGroupDialogSkeleton 
        show={show}
        onClose={onClose}
        onDialogActionButtonClick={onEditShortcutGroupFromInput}
        dialogTitle="Rename Shortcut Group"
        dialogActionButtonLabel="Rename"
        dialogFieldLabel="To"
        extraDialogField={getExtraDialogField()}
        shortcutGroupName={shortcutGroupName}
        dialogPaperClassName="edit-shortcut-dialog-paper"
        disableActionButtonIfInputNotChanged
    />;
};

export default EditShortcutGroupDialog;
